import { IIconProps } from './icon';

export const IconTrashCan = ({ style = {}, cy }: IIconProps) => {
  return (
    <svg
      width="10"
      height="12"
      viewBox="0 0 10 12"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      data-cy={`IconTrashCan${cy}`}
    >
      <path
        d="M0.99998 10.6667C0.99998 11.4 1.59998 12 2.33331 12H7.66665C8.39998 12 8.99998 11.4 8.99998 10.6667V2.66667H0.99998V10.6667ZM9.66665 0.666667H7.33331L6.66665 0H3.33331L2.66665 0.666667H0.333313V2H9.66665V0.666667Z"
        fill="currentColor"
      />
    </svg>
  );
};
